import { Button, Layout, Modal } from 'antd';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import EventIntrusionDetection from '../../assets/icons/event_intrusion_detection.svg';
import * as SERVICE from '../../constants/service.types';
import * as ACTIONS from '../../redux/actions';
import {
  popupVideoStorageFileByTimeReturn,
  socketEmitEvent,
} from '../../redux/actions';
import PlayerComponent from '../Player';
import ServerDetector from '../ServerDetector';
import UploadVideoCamera from '../UploadVideoCamera';
import AppHeader from './AppHeader';
import './index.scss';

const { Content } = Layout;

const AppLayout = withRouter((props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    openUploadFilesDialog,
    notifications,
    namespace,
    generateLinkStorageFileByTime,
    popupVideoStorageFileByTime,
  } = useSelector((state) => state);
  const [isShowNotif, setIsShowNotif] = useState(false);
  const [dataNotification, setDataNotifcation] = useState([]);
  const deviceInfo = useMemo(
    () =>
      popupVideoStorageFileByTime?.dataDetail?.extraInfo
        ? JSON.parse(popupVideoStorageFileByTime?.dataDetail?.extraInfo || '{}')
        : {},
    [popupVideoStorageFileByTime]
  );

  useEffect(() => {
    const { pathname } = props.location;
    if (pathname === '/login') {
      history.push('/');
    }
  }, [history, props.location]);

  useEffect(() => {
    if (notifications) {
      const temple = notifications;
      setDataNotifcation(orderDate(temple));
    }
  }, [notifications]);

  const orderDate = (arr) => {
    arr.sort(function (a, b) {
      return moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf();
    });
    return arr;
  };

  const handleCancel = () => {
    dispatch(
      popupVideoStorageFileByTimeReturn({
        dataDetail: undefined,
        isModalVisible: false,
      })
    );
  };

  const showModal = (data) => {
    dispatch(
      popupVideoStorageFileByTimeReturn({
        dataDetail: data,
        isModalVisible: true,
      })
    );
  };

  const onGenerateLinkStorageByTime = (itemDetail) => {
    const dataTimeRequest = new Date().getTime();
    let data = {
      ipAddress: '0.0.0.0',
      deviceSerial: itemDetail?.extraInfo
        ? JSON.parse(itemDetail?.extraInfo)?.serial
        : '',
      queryTime: moment(
        itemDetail?.extraInfo && JSON.parse(itemDetail?.extraInfo)?.timestamp
          ? JSON.parse(itemDetail?.extraInfo)?.timestamp * 1000
          : itemDetail?.updatedAt
      ).format('YYYY-MM-DD HH:mm:ss'),
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.GENERATE_LINK_STORAGE_FILE_BY_TIME,
      requestId: dataTimeRequest,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  useEffect(() => {
    if (namespace && popupVideoStorageFileByTime?.isModalVisible) {
      onGenerateLinkStorageByTime(popupVideoStorageFileByTime?.dataDetail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespace, popupVideoStorageFileByTime?.isModalVisible]);

  return (
    <DndProvider backend={HTML5Backend}>
      <ServerDetector>
        <Layout className="layout">
          <AppHeader
            isShowNotif={isShowNotif}
            setIsShowNotif={setIsShowNotif}
          />
          <Content>
            <div className="main-container">{props.children}</div>
            <div className="space-footer" />
          </Content>
          {openUploadFilesDialog && <UploadVideoCamera />}
          <div className="notification-device">
            {isShowNotif && (
              <div className="list-notification-detect-object">
                {dataNotification?.slice(0, 10)?.map((itemNotification) => (
                  <div className="item-notification">
                    <div className="item-notification-title">
                      {itemNotification.extraInfo &&
                        JSON.parse(itemNotification.extraInfo) &&
                        JSON.parse(itemNotification.extraInfo).imageUrl && (
                          <img
                            onClick={() => {
                              dispatch(
                                ACTIONS.popupVideoStorageFileByTimeReturn({
                                  dataDetail: itemNotification,
                                  isModalVisible: true,
                                })
                              );
                            }}
                            src={
                              JSON.parse(itemNotification.extraInfo).imageUrl
                            }
                            style={{
                              width: '80px',
                              cursor: 'pointer',
                              objectFit: 'cover',
                            }}
                            alt="atm-map"
                          />
                        )}
                      <div className="item-note">
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <div style={{ color: '#AEAEAE', fontSize: '11px' }}>
                            {moment(itemNotification?.updatedAt).format(
                              'HH:mm:ss DD-MM-YYYY'
                            )}
                          </div>
                        </div>
                        <div
                          onClick={() => showModal(itemNotification)}
                          style={{
                            color: 'rgb(245, 47, 57)',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                          }}
                        >
                          <img
                            src={EventIntrusionDetection}
                            alt="imageNotification"
                            style={{ marginRight: '5px', marginBottom: '3px' }}
                          />
                          {t('Notification')}
                        </div>
                        <div>{itemNotification?.content}</div>
                        <div>{itemNotification?.note}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Layout>
        <Modal
          className="modal-detail-notification"
          title={
            <div>
              <div>
                {popupVideoStorageFileByTime?.dataDetail?.content ?? ''}
              </div>
              <div
                style={{ color: '#797979', fontSize: '12px', marginTop: '3px' }}
              >
                {moment(
                  popupVideoStorageFileByTime?.dataDetail?.extraInfo &&
                    JSON.parse(
                      popupVideoStorageFileByTime?.dataDetail?.extraInfo
                    )?.timestamp
                    ? JSON.parse(
                        popupVideoStorageFileByTime?.dataDetail?.extraInfo
                      )?.timestamp * 1000
                    : popupVideoStorageFileByTime?.dataDetail?.updatedAt
                ).format('HH:mm:ss DD-MM-YYYY')}
              </div>
            </div>
          }
          visible={popupVideoStorageFileByTime?.isModalVisible ?? false}
          onCancel={handleCancel}
          style={{ top: 50 }}
          width="920px"
          bodyStyle={{ textAlign: 'center' }}
          footer={[
            <Button key="back" onClick={handleCancel}>
              {t('Close')}
            </Button>,
          ]}
        >
          {popupVideoStorageFileByTime?.dataDetail && (
            <div className="video-storage-notification">
              <PlayerComponent
                type="video"
                src={
                  generateLinkStorageFileByTime?.[deviceInfo.serial]?.secureLink
                }
                seekTo={
                  generateLinkStorageFileByTime?.[deviceInfo.serial]
                    ?.startSecond
                    ? generateLinkStorageFileByTime?.[deviceInfo.serial]
                        ?.startSecond >= 5
                      ? generateLinkStorageFileByTime?.[deviceInfo.serial]
                          ?.startSecond - 5
                      : generateLinkStorageFileByTime?.[deviceInfo.serial]
                          ?.startSecond
                    : null
                }
              />
            </div>
          )}
        </Modal>
      </ServerDetector>
    </DndProvider>
  );
});

AppLayout.propTypes = {};

export default AppLayout;
